// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"92":"10124b0d","134":"27610105","253":"bb2e9a7e","260":"22a40bc9","418":"386cbd81","441":"f35d724b","484":"a98a1c1a","510":"859b2cd0","537":"7c214788","565":"6b943c10","839":"c421021a","889":"3adfaa9c","897":"bf083e93"}[chunkId] + ".js";
};